import { UniversalMenuSection as UniversalMenuSectionComponent } from "./MenuComponents";
import {
  fileManagementMenuConfig,
  nonConformityMenuConfig,
} from "./adminMenuConfigs";

const UniversalMenuSections = () => (
  <>
    <UniversalMenuSectionComponent config={fileManagementMenuConfig} />
    <UniversalMenuSectionComponent config={nonConformityMenuConfig} />
  </>
);

export default UniversalMenuSections;
